import { AddressElement, PaymentElement } from '@stripe/react-stripe-js'
import { setUserVars } from '@fullstory/browser'
import { TStripeFields } from '@/src/modules/checkout/utilities/types'

export type TStripeProps = {
    setIsComplete: Function
}

export default function StripePaymentFields({ setIsComplete }: TStripeProps) {
    return (
        <>
            <PaymentElement
                id="payment-element"
                options={{
                    fields: {
                        billingDetails: {
                            address: {
                                country: 'never',
                            },
                        },
                    },
                }}
                onChange={(event) => {
                    setIsComplete((prev: TStripeFields) => {
                        return { ...prev, payment: event.complete }
                    })
                }}
            />
            <br />
            <br />
            <AddressElement
                options={{
                    mode: 'billing',
                    allowedCountries: ['US'],
                }}
                onChange={(event) => {
                    // set FullStory vars
                    try {
                        setUserVars({
                            displayName: event?.value?.name,
                        })
                    } catch (e) {
                        console.debug(e)
                    }

                    // determine if stripe field is complete
                    setIsComplete((prev: TStripeFields) => {
                        return { ...prev, address: event.complete }
                    })
                }}
            />
        </>
    )
}
